/* ppz-mag-oggi.js — la data di oggi nelle pagine «rivista».
 *
 * Contratto:
 *   [data-ppz-mag-data]    ci finisce «5 ottobre 2026»
 *   [data-ppz-mag-giorno]  ci finisce «Lunedì» seguito da uno spazio che non va a capo
 *
 * Il Liquid (snippets/ppz-mag-oggi) scrive gia' la data con l'ora del negozio:
 * senza JavaScript resta quella. Qui la si riscrive con l'orologio di chi
 * guarda, perche' la pagina puo' arrivare dalla memoria di Shopify con la data
 * di ieri. Lo caricano piu' sezioni: rifarlo due volte non cambia niente.
 */
(function () {
  function scrivi() {
    var oggi = new Date();
    var giorno, data;
    try {
      giorno = oggi.toLocaleDateString('it-IT', { weekday: 'long' });
      data = oggi.toLocaleDateString('it-IT', { day: 'numeric', month: 'long', year: 'numeric' });
    } catch (e) {
      return;
    }
    if (giorno) {
      document.querySelectorAll('[data-ppz-mag-giorno]').forEach(function (el) {
        el.textContent = giorno.charAt(0).toUpperCase() + giorno.slice(1) + ' ';
      });
    }
    if (data) {
      document.querySelectorAll('[data-ppz-mag-data]').forEach(function (el) {
        el.textContent = data;
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scrivi);
  } else {
    scrivi();
  }

  document.addEventListener('shopify:section:load', scrivi);
})();
